import { Component, OnInit, TemplateRef } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { DatePipe } from '@angular/common';
import { forwardRef, Input, ViewChild } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDatepicker, MatDialog } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { AddLeaveComponent } from 'app/shared/common/add-leave/add-leave.component';
import { ToastrService } from 'ngx-toastr';

const moment = _rollupMoment || _moment;

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.scss'],
  animations: fuseAnimations,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_MODE_FORMATS },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HolidaysComponent),
      multi: true,
    },
  ],
})
export class HolidaysComponent implements OnInit {

  holidayCols = [
    { field: 'position', header: 'Position' },
    { field: 'date', header: 'Date' },
    { field: 'day', header: 'Day' },
    { field: 'holidayName', header: 'Holiday Name' },
    { field: 'actions', header: 'Action' }
  ];
  tenantId: any;
  leaveResults = [];
  leaveResCount = 12;
  profileId = '';
  monthsOfTheYear = [
    { value: 0, month: 'January' },
    { value: 1, month: 'February' },
    { value: 2, month: 'March' },
    { value: 3, month: 'April' },
    { value: 4, month: 'May' },
    { value: 5, month: 'June' },
    { value: 6, month: 'July' },
    { value: 7, month: 'August' },
    { value: 8, month: 'September' },
    { value: 9, month: 'October' },
    { value: 10, month: 'November' },
    { value: 11, month: 'December' }
  ]
  nonWorkingDays = [];
  holidaysList = [];
  selectedLeaveYear = new Date();
  profileIds = [];
  allEmployeeLeaveResults = [];
  totalRecords = 0;
  currentEmployeeLeaveResults = [];
  searchValue = '';
  userName = '';
  userImage = '';
  selectedLeaveList = [];
  @ViewChild('deleteLeavePopup', { static: false }) deleteLeavePopup: TemplateRef<any>;
  selectedLeaveDate = '';
  selctedResource = '';
  holidayCount = 0;
  selectedHoliday = new Date();
  datePipe = new DatePipe('en-US');
  selectedHolidayYear = new Date().getFullYear();

  _max: Moment;
  @Input()
  get max(): number | Date {
    return this._max ? this._max.year() : undefined;
  }
  set max(max: number | Date) {
    if (max) {
      const momentDate =
        typeof max === 'number' ? moment([max, 0, 1]) : moment(max);
      this._max = momentDate.isValid() ? momentDate : undefined;
    }
  }

  _min: Moment;
  @Input()
  get min(): number | Date {
    return this._min ? this._min.year() : undefined;
  }
  set min(min: number | Date) {
    if (min) {
      const momentDate =
        typeof min === 'number' ? moment([min, 0, 1]) : moment(min);
      this._min = momentDate.isValid() ? momentDate : undefined;
    }
  }

  touchUi = false;
  empRole = '';
  selectedYear = new Date();

  @ViewChild(MatDatepicker, { static: false }) _picker: MatDatepicker<Moment>;
  _inputCtr1: FormControl = new FormControl();

  /** send the focus away from the input so it doesn't open again */
  _takeFocusAway = (datepicker: MatDatepicker<Moment>) => { };

  constructor(
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    public dialog: MatDialog,
    private toastr: ToastrService
  ) {

  }

  async ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;

    await this.getHolidays();
    this.getHolidayList();
  }

  async getHolidays() {
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('year', this.selectedHolidayYear);
    const leaveResults = await holidayQuery.find();
    if (leaveResults.length > 0) {
      let holidayList = leaveResults[0].get('dateList') == undefined ? {} : leaveResults[0].get('dateList');
      for (let months in holidayList) {
        if (holidayList[months].length != 0) {
          let parsedMonths = parseInt(months);
          holidayList[months].forEach(element => {
            const officialLeaves = new Date(this.selectedHolidayYear, parsedMonths, element);
            const epochLeaves = officialLeaves.getTime();
            this.nonWorkingDays.push(epochLeaves);
          });
        }
      }
    }
    let date = new Date();
    let year = date.getFullYear();
    let totalMonths = 12;
    for (let i = 0; i < totalMonths; i++) {
      let k = i + 1;
      let daysInMonth = new Date(year, k, 0).getDate();
      for (let j = 0; j < daysInMonth; j++) {
        let datesAll = new Date(year, i, j);
        let dayOfWeek = datesAll.getDay();
        let dateOfMonth = datesAll.getDate();
        let isEvenWeek = Math.ceil(dateOfMonth / 7);
        let epochOddDates = datesAll.getTime();
        if (dayOfWeek == 0) {
          if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
            this.nonWorkingDays.push(epochOddDates);
          }
        } if (dayOfWeek == 6 && isEvenWeek % 2 != 0) {
          if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
            this.nonWorkingDays.push(epochOddDates);
          }
        }
      }
    }
    let previousYear = year - 1;
    let daysInMonthLast = new Date(previousYear, 12, 0).getDate();
    for (let d = 1; d <= daysInMonthLast; d++) {
      let lastdatesAll = new Date(previousYear, 11, d);
      let lastdayOfWeek = lastdatesAll.getDay();
      let lastdateOfMonth = lastdatesAll.getDate();
      let lastisEvenWeek = Math.ceil(lastdateOfMonth / 7);
      let lastepochOddDates = lastdatesAll.getTime();
      if (lastdayOfWeek == 0) {
        if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
          this.nonWorkingDays.push(lastepochOddDates);
        }
      } if (lastdayOfWeek == 6 && lastisEvenWeek % 2 != 0) {
        if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
          this.nonWorkingDays.push(lastepochOddDates);
        }
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  async holidayYearSelectedHandler(chosenDate: Moment, datepicker: MatDatepicker<Moment>) {
    this.selectedHoliday = chosenDate.toDate();
    this.selectedYear = this.selectedHoliday;
    this.selectedHolidayYear = new Date(this.selectedHoliday).getFullYear();
    this.getHolidayList();
    datepicker.close();

    if (!this.isYearEnabled(chosenDate.year())) {
      return;
    }
    chosenDate.set({ date: 1 });
    this._inputCtr1.setValue(chosenDate, { emitEvent: false });
    this.onChange(chosenDate.toDate());
    this.onTouched();
  }

  openDatepickerOnClick(datepicker: MatDatepicker<Moment>) {
    if (!datepicker.opened) {
      datepicker.open();
    }
  }

  // Function to call when the date changes.
  onChange = (year: Date) => { };

  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => { };

  /** Whether the given year is enabled. */
  isYearEnabled(year: number) {
    // disable if the year is greater than maxDate lower than minDate
    if (
      year === undefined ||
      year === null ||
      (this._max && year > this._max.year()) ||
      (this._min && year < this._min.year())
    ) {
      return false;
    }

    return true;
  }

  async getHolidayList() {
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('tenantId', this.tenantId);
    holidayQuery.equalTo('year', this.selectedHolidayYear);
    const leaveResults = await holidayQuery.find();
    this.holidaysList = [];
    if (leaveResults.length > 0) {
      let data = leaveResults[0].get('holidayDetails');
      data.sort(function (a, b) {
        if (new Date(a.date).getTime() < new Date(b.date).getTime()) { return -1; }
        if (new Date(a.date).getTime() > new Date(b.date).getTime()) { return 1; }
      });
      let i = 0;
      for (const element of data) {
        i = i + 1;
        this.holidaysList.push({
          position: i,
          date: element.date,
          holidayName: element.holidayName
        });
      }
      this.holidayCount = this.holidaysList.length;
    }
  }

  openLeaveDialog() {
    const dialogRef = this.dialog.open(AddLeaveComponent, {
      width: '500px',
      data: { isEdit: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getHolidayList();
    });
  }

  editLeave(leaveDate) {
    const dialogRef = this.dialog.open(AddLeaveComponent, {
      width: '500px',
      data: { date: leaveDate, isEdit: true }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getHolidayList();
    });
  }

  deleteConfirmation(leaveDate) {
    this.selectedLeaveDate = leaveDate;
    this.dialog.open(this.deleteLeavePopup, {
      width: '300px'
    });
  }

  async deleteLeave() {
    let year = this.selectedLeaveDate ? new Date(this.selectedLeaveDate).getFullYear() : new Date().getFullYear();
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('year', year);
    const leaveResults = await holidayQuery.find();
    if (leaveResults.length > 0) {
      let data = leaveResults[0];
      let leaveDetails = data.get('holidayDetails');
      let index = leaveDetails.findIndex(x => x.date == this.selectedLeaveDate);

      // Removing data
      let dateList = data.get('dateList');
      let month = new Date(this.selectedLeaveDate).getMonth();
      let date = new Date(this.selectedLeaveDate).getDate();
      var foundIndex = dateList[month].findIndex(x => x == date);
      dateList[month].splice(foundIndex, 1);
      data.set('dateList', dateList);

      if (index != -1) {
        leaveDetails.splice(index, 1);
        data.set('holidayDetails', leaveDetails);
        let res = await data.save();
        this.toastr.success('Deleted successfully');
        this.dialog.closeAll();
      }
      this.getHolidayList();
    }
  }

  closepopup() {
    this.dialog.closeAll();
  }


}

